import React, { FC } from 'react'

const NoMatchScreen: FC = () => <div>NoMatchScreen</div>

export default NoMatchScreen
